var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:youtube"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6667 15.9994L14 18.6661V13.3328L18.6667 15.9994Z",
    fill: "#5B6AF1",
    stroke: "#5B6AF1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.6665 16.942L2.6665 15.0554C2.6665 11.1954 2.6665 9.26471 3.87317 8.02338C5.08117 6.78071 6.98251 6.72738 10.7838 6.61938C12.5838 6.56871 14.4238 6.53271 15.9998 6.53271C17.5745 6.53271 19.4145 6.56871 21.2158 6.61938C25.0172 6.72738 26.9185 6.78071 28.1252 8.02338C29.3332 9.26471 29.3332 11.1967 29.3332 15.0554V16.942C29.3332 20.8034 29.3332 22.7327 28.1265 23.9754C26.9185 25.2167 25.0185 25.2714 21.2158 25.378C19.4158 25.43 17.5758 25.466 15.9998 25.466C14.2608 25.4608 12.522 25.4315 10.7838 25.378C6.98251 25.2714 5.08117 25.218 3.87317 23.9754C2.6665 22.7327 2.6665 20.802 2.6665 16.9434V16.942Z",
    stroke: "#5B6AF1",
    strokeWidth: 1.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirYoutube);
export default __webpack_public_path__ + "static/media/iconoir_youtube.210e15df32931eb03f1b60e721693c03.svg";
export { ForwardRef as ReactComponent };